import React from "react"
import { createStyles, forwardRef, styled } from "@design-system/styled-system"
import { BoxProps } from "./types"

export const Box = styled.div
Box.displayName = "Box"

/**
 * Only `size` would be allowed
 */

export interface SquareProps
  extends Omit<BoxProps, "size" | "boxSize" | "width" | "height" | "w" | "h"> {
  /**
   * The size (width and height) of the square
   */
  size?: BoxProps["width"]
  /**
   * If `true`, the content will be centered in the square
   */
  centerContent?: boolean
}

export const Square = forwardRef<SquareProps, "div">((props, ref) => {
  const { size, centerContent = true, style, ...rest } = props
  return (
    <Box
      {...rest}
      ref={ref}
      width={size}
      height={size}
      style={[styles.root, centerContent && styles.centerContent, style]}
    />
  )
})
Square.displayName = "Square"

export const Circle = forwardRef<SquareProps, "div">((props, ref) => {
  const { size, style, ...rest } = props
  return (
    <Square {...rest} size={size} ref={ref} style={[styles.circle, style]} />
  )
})
Circle.displayName = "Circle"

export const Container = forwardRef<BoxProps, "div">((props, ref) => {
  return (
    <Box
      ref={ref}
      width="100%"
      marginHorizontal="auto"
      maxWidth={1328}
      {...props}
    />
  )
})
Container.displayName = "Container"

export const Center = forwardRef<BoxProps, "div">((props, ref) => {
  const { style, ...rest } = props
  return <Box {...rest} ref={ref} style={[styles.centerContent, style]} />
})
Center.displayName = "Center"

const styles = createStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexGrow: 0,
  },
  centerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  circle: {
    borderRadius: theme.borderRadii.full,
  },
}))
